import React from 'react';
import { useFirebase } from '../firebase/context';
import { WizardContext } from '../contexts/WizardContext/WizardContext';
import SignOut from './SignOut';
import { interpolateAppText, useAppTexts } from '../hooks/useAppTexts';
import { useNonNullableContext } from '../hooks/useNonNullableContext';
import { useLanguage } from '../hooks/useLanguage';

const Footer = () => {
  const firebase = useFirebase();
  const appTexts = useAppTexts();
  const { language, languageSettingsEnabled } = useLanguage();

  const { nrOfSelectedItems } = useNonNullableContext(WizardContext);
  const { supportEmail, privacyPolicyUrl, privacyPolicyUrlTranslated } =
    firebase.publicConfig ?? {};

  const url = languageSettingsEnabled
    ? privacyPolicyUrlTranslated?.[language] || privacyPolicyUrl
    : privacyPolicyUrl;

  return (
    <div className={`footer ${nrOfSelectedItems > 0 ? 'has-expanded-margin' : ''}`}>
      <div>{interpolateAppText(appTexts.footer.default, { supportEmail: supportEmail })}</div>
      {url && (
        <div className="additional-links">
          <a href={url} target="_blank" rel="noreferrer">
            {appTexts.footer.privacyPolicy}
          </a>
        </div>
      )}
      {firebase.auth.currentUser && <SignOut text={appTexts.generic.signOut} isLink />}
    </div>
  );
};

export default Footer;
